import {Component, React, observer} from '$src/handy'
import * as css from './EditLocationModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import {getSnapshot} from 'mobx-state-tree'
import editHousingCorporationMunicipality from '$src/api/endpoints/housingCorporations/editHousingCorporationMunicipality'

interface Props {
  onRequestClose: Function
  cid: string | number
  onUpdateNeeded: Function
}

interface State {
  error?: string
  submitting: boolean
}

@observer
export default class EditMunicipalityModal extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, submitting: false}
  }

  onSubmit = (fields: {municipality: string}) => {
    this.setState({error: undefined, submitting: true})

    const regex = /(\b[a-z](?!\s))/g
    const municipality = fields.municipality.replace(regex, function(
      field: string,
    ) {
      return field.toUpperCase()
    })

    this.callEndpoint(editHousingCorporationMunicipality, {
      municipality,
      cid: this.props.cid,
    }).then(
      () => {
        this.setState({submitting: false})
        this.props.onUpdateNeeded(municipality)
        this.props.onRequestClose()
      },
      (error: any) => {
        this.setState(s => ({
          ...s,
          error: error.message || 'Unauthorized',
          submitting: false,
        }))
      },
    )
  }

  render() {
    const {props} = this

    let initialValues = undefined
    const data: {municipality?: string} = getSnapshot(
      // @ts-ignore
      this.store.housingCorporations.byId.get(props.cid),
    )
    initialValues = {
      municipality: data.municipality,
    }

    return (
      <GenericModal
        onHide={props.onRequestClose}
        css={{box: {container: css.box}}}
      >
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          <TextInput.Field
            name="municipality"
            type="text"
            label="MUNICIPALITY"
          />
          <div className={css.bottom}>
            {this.state.error && (
              <div className={css.error}>Error occured: {this.state.error}</div>
            )}
            <GenericButton
              variant="bold"
              type="submit"
              disabled={this.state.submitting}
            >
              EDIT Municipality
            </GenericButton>
          </div>
        </Form>
      </GenericModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/housingCorporations/EditMunicipalityModal.tsx